module.exports = __webpack_public_path__ + "src/img/bus.8862b8ad.svg";